import { render, staticRenderFns } from "./satir.vue?vue&type=template&id=023dc100"
import script from "./satir.vue?vue&type=script&lang=js"
export * from "./satir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports